import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=101a0b34&scoped=true&"
import script from "./Reviews.vue?vue&type=script&lang=js&"
export * from "./Reviews.vue?vue&type=script&lang=js&"
import style0 from "./Reviews.vue?vue&type=style&index=0&id=101a0b34&prod&lang=css&"
import style1 from "./Reviews.vue?vue&type=style&index=1&id=101a0b34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a0b34",
  null
  
)

export default component.exports